import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/outline/documentSymbolsOutline.js';
import './vscode/src/vs/workbench/contrib/outline/browser/outline.contribution.js';
import { IOutlineService } from 'vscode/vscode/vs/workbench/services/outline/browser/outline.service';
import { OutlineService } from './vscode/src/vs/workbench/services/outline/browser/outlineService.js';

function getServiceOverride() {
    return {
        [( IOutlineService.toString())]: new SyncDescriptor(OutlineService, [], true)
    };
}

export { getServiceOverride as default };
